<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre13"><span id="Seite_1" title="[S. 1]"></span></p>
<div class="figcenter4" id="p001_ill">
<img alt="" class="w" id="id-470388598936102177" src="Images/img0002.jpg"/>
<div class="caption1">Türkische Soldaten auf dem Wege nach Nesibin, Mosul
  und Bagdad.</div>
</div>
<h2 class="nopad" id="Erstes_Kapitel"><span class="s11">Erstes Kapitel.</span><br class="calibre10"/>
<b class="calibre14">Die Türkei im Weltkriege.</b></h2>
</div>
<p class="s12">Stockholm, 7. Mai 1917.</p>
<p class="calibre13"><span>W</span>er dieses Buch in der Erwartung zur Hand nimmt, eine ausführliche
Schilderung des Anteils der Türkei am Weltkrieg zu finden, wird schon,
ehe er bis Bagdad gekommen ist, enttäuscht ausrufen: Aber das ist ja
kein Kriegsbuch! Das ist ja nur eine Reisebeschreibung!</p>
<p class="calibre13">Er hat vollkommen recht. Nicht der Krieg lockte mich zu neuen
Abenteuern. Davon hatte ich an den europäischen Fronten genug gesehen.
Diesmal sehnte ich mich vor allem danach, die Weltreiche des Altertums,
Assyrien und Babylonien, und die Ergebnisse der modernen Forschung auf
diesem ehrwürdigsten Boden der Erde kennen zu lernen. Ich wollte die
altberühmten Städte sehen, die der Spaten der Archäologen jetzt aus
vieltausendjährigem Schlummer geweckt hat.</p>
<p class="calibre13"><span id="Seite_2" title="[S. 2]"></span></p>
<p class="calibre13">Den Leser an der überreichen Fülle meiner Eindrücke teilnehmen zu
lassen, ist die vornehmste Aufgabe dieses Buches. Bald aber wird er
merken, daß meine Reise in kriegerischer Zeit vor sich ging. Er hört
den Schritt marschierender Soldaten und sieht deutsche Batterien
in türkischen Diensten den königlichen Euphrat hinabfahren. Der
Kanonendonner von Kut-el-Amara dringt an sein Ohr, und ich kann ihm
einige Mitteilungen über den Vormarsch der Engländer in Mesopotamien
nicht ersparen. Doch diese Gegenwartsbilder ziehen nur flüchtig vorüber
vor dem machtvollen Hintergrund des Altertums.</p>
<p class="calibre13">Den Kampf der Osmanen gegen Rußland kann ein Schwede nicht aufmerksam
genug verfolgen. Denn er berührt die Zukunft seiner Heimat näher,
als viele meiner Landsleute zugeben wollen. Bisher war Rußland auch
<em class="gesperrt">unser</em> Erbfeind — die nächste Zukunft wird zeigen, ob der
jetzige Umsturz den Erbfeind in einen Freund verwandelt hat. Seit Karl
XII. den Europäern die Augen für die moskowitische Gefahr öffnete
und die Vernichtung des slawischen Großstaates als das unumstößliche
politische Ziel seiner Nachbarn bezeichnete, haben Schweden und die
Türkei das gleiche Lebensinteresse gehabt. Der Sieg des einen war
auch des andern Vorteil, die Niederlage des einen auch der Schaden
des andern. Schwedens Mißgeschick gab den russischen Zaren stets die
Hände im Süden frei. Türkische Niederlagen sicherten ihnen den Rücken
vor gefährlichen Feinden, wenn sie es für angebracht hielten, ihre
Aufmerksamkeit auf unsre Grenzen zu richten.</p>
<p class="calibre13">Das Gemeinsame in den politischen Bedürfnissen Schwedens und der
Türkei hat dennoch nicht vermocht, sie zu förderlicher Zusammenarbeit
zu vereinen, nicht einmal da, wo es nur die Abwehr galt. Und doch hat
die geographische Lage beider, die die Flanken des moskowitischen
Reiches umfaßt, jedem von ihnen mit oder gegen seinen Willen eine
außerordentlich wichtige Rolle aufgezwungen. Schweden hält Rußland vom
Meere ab und sperrt seine Verbindungen mit Westeuropa. Das bisherige
Rußland — unter dem Zepter des Zaren — hat unser bloßes Dasein stets
als einen erstickenden Druck empfunden; die Lehren des Weltkrieges
haben diese Wahrheit nur bestätigt. Rußlands auswärtige Politik will
diese Fesseln sprengen. Andrerseits kann die künftige Sicherheit
Schwedens und der Türkei zu keinem billigeren Preise errungen werden,
als durch<span id="Seite_4" title="[S. 4]"></span> Verwirklichung der Pläne Karls XII.! Denn die neue
Staatsform, mit der Rußland soeben die Welt überrascht hat, gibt
keinerlei Bürgschaft für die Zukunft. Nichts könnte törichter sein, als
blind auf ihren Bestand zu vertrauen!</p>
<div class="figcenter5" id="p003_ill">
<img alt="" class="w1" id="id-6981232704709735871" src="Images/img0003.jpg"/>
<div class="caption1"><em class="gesperrt">Halil Pascha</em>,<br class="calibre8"/>
  der Nachfolger des Feldmarschalls von der Goltz.<br class="calibre8"/>
<span class="s1">Mit eigenhändiger Unterschrift.</span>
<div class="linkedimage"><span id="p003_ill_gross">⇒<br class="calibre8"/>
<span class="s1">GRÖSSERES BILD</span></span></div>
</div>
</div>
<p class="calibre13">Die Stellung der Türkei zur westeuropäischen Frage im modernen Sinn
ergab sich, als die Moskowiter ohne historisches Recht den Weg nach
dem Bosporus und den Dardanellen einschlugen und ohne Umschweife
erklärten, ihr Ziel sei „Zarigrads (Konstantinopels) Befreiung“! Zur
selben Zeit wollte Karl XII. alle Kräfte sammeln zum gemeinsamen Kampf
gegen einen Feind, dessen Charakter und Entwicklungsmöglichkeiten er
wie kein andrer vor oder nach ihm mit prophetischem Blick durchschaute.
Vergebens aber rief er Schweden, Polen und Türken auf. Sein Plan kam
nicht zur Ausführung, nicht zum wenigsten weil westeuropäische Mächte
den Russen Helferdienste leisteten. Nach Karls XII. Tode war Schweden
wie Polen und die Türkei durch innere Zwistigkeiten geschwächt, die
Rußland und England — damals wie jetzt in brüderlicher Eintracht —
anfachten und schürten. Polen verschwand. Schweden wurde einstweilen
durch Gustav III. gerettet. Den Türken aber öffnete der verhängnisvolle
Vertrag von Kütschük-Kainardschi (1774) die Augen über die dunklen
Pläne, die schon Zar Peter der Große im Schilde führte. Damals schon
begann der Marsch über türkische Gebiete, die dem Vordringen Rußlands
nach dem Mittelmeer im Wege lagen.</p>
<p class="calibre13">Der Plan der Entente, die Mittelmächte in dem jetzt tobenden Weltkrieg
zu zerschmettern, hat seine Wurzeln in der Balkanhalbinsel. Über
das Ziel der Russen waren die Osmanen im klaren: sie <em class="gesperrt">wußten</em>,
daß sich England und Rußland, um ihre Absicht durchzusetzen, über
türkisches Gebiet hinweg die Hand reichen <em class="gesperrt">mußten</em>, und daß
<em class="gesperrt">alles</em> aufgeboten werden sollte, sich freie Bahn zu erzwingen.
Für beide Teile handelte es sich also um einen Kampf auf Leben und Tod.
Als daher die Hohe Pforte vor der Wahl stand: Krieg oder Untergang? gab
es für sie kein Bedenken mehr. Zum erstenmal nach zweihundert Jahren
lebten Karls XII. Gedanken wieder auf, und aufs neue erhob sich das
Ziel, an das er Schwedens ganze Kraft gesetzt hatte. Diesmal waren auch
die Nachbarn im Westen auf dem Posten. Nur Karls XII. eigenes Land
fehlte in der Reihe — vom Geist des Eisenkopfs war bei den<span id="Seite_5" title="[S. 5]"></span> Nachkommen
seiner Helden wenig mehr zu spüren. Immerhin wirkte Schweden durch
seine geographische Lage.</p>
<p class="calibre13">Tatsächlich <em class="gesperrt">hatten</em> die Türken keine andere Wahl, wenn sie
am Leben bleiben wollten. Die neutrale Türkei hätte dasselbe
tragische Schicksal getroffen wie das verfolgte, ausgehungerte,
erwürgte Griechenland, dessen einziges Verbrechen war, daß es
dem weltzerfleischenden Kampfe fernbleiben wollte. Dann hätte
Konstantinopel jetzt eine russische und englische Besatzung, wie sich
Athen der englischen und französischen erfreut.</p>
<p class="calibre13">Hätte sich der Türkei im Laufe des Weltkriegs jemals eine Spur
von Zweifel oder Ermüdung bemächtigt, so sorgte der russische
Ministerpräsident Trepow in seiner Dumarede vom 2. Dezember 1916 dafür,
daß sie aufs neue zu eisernem Widerstand zusammengeschmiedet wurde. Er
gestand nämlich, eine mit Großbritannien, Frankreich und Italien im
Jahr 1915 geschlossene Übereinkunft habe „definitiv Rußlands Recht auf
die Meerengen und auf Konstantinopel festgestellt“. Sein oder Nichtsein
stand also für die Türken auf dem Spiele.</p>
<p class="calibre13">Wer nun geglaubt hat, das neue Rußland werde auf solche
Kriegsziele verzichten, erlebte eine große Enttäuschung. Die erste
Revolutionsregierung wenigstens verharrte bei dem Anspruch auf die
Dardanellen und Konstantinopel, und der Minister des Äußeren Miljukow
übernahm in unveränderter Form den „russischen Reichsgedanken“, den
Trepow in die Worte gefaßt hatte: „Die Schlüssel zum Bosporus und zu
den Dardanellen, Olegs Schild über dem Tor Konstantinopels — das ist
der Jahrhunderte alte innerste Traum des russischen Volkes zu allen
Zeiten seines Daseins.“</p>
<p class="calibre13">Die junge Türkei hatte also Grund genug, dem Umschwung der Dinge in
Rußland, den sie — selbst ein Kind der Revolution — an sich mit
Befriedigung begrüßt hatte, größtes Mißtrauen entgegen zu bringen.
Als unlängst der Großwesir Talaat Pascha der Presse seine Gedanken
darüber mitteilte, tat er das mit den wohlüberlegten Worten: „Wir sehen
indes mit Bedauern, daß der Gedanke der Revolution von aggressiven
Absichten durchaus nicht frei ist. Miljukows ‚ehrenvoller‘ Friede setzt
eine Lösung der türkischen Frage zugunsten Rußlands voraus! Ob die
russischen Liberalen diese alte Lehre von Angriff und Feindseligkeit
billigen,<span id="Seite_6" title="[S. 6]"></span> wissen wir nicht. Wenn aber das russische Volk das
verhängnisvolle Erbe des Zarismus als Richtschnur nimmt, dürfte es
zwecklos sein, von Frieden zu reden.“ —</p>
<p class="calibre13">Was hat im übrigen die Türkei dadurch gewonnen, daß sie
unerschütterlich den Kurs beibehielt, den sie bei Beginn des Krieges
einschlug? Nun, <em class="gesperrt">sie hat ihr eigenes Dasein für eine Zeitspanne
gesichert, deren Weite wir noch nicht überblicken können</em>. Indem
sie die Verbindung zwischen Rußland und England verhinderte, hat
sie wirksam zum Zusammenbruch des Zarenreichs beigetragen. Rußlands
Kraft ist in Auflösung begriffen — kein Staat kann zu gleicher
Zeit mit Erfolg Krieg führen und eine Revolution durchmachen. In
diesem ungeheuern Kampfe, der nun seinem Ende zugeht, können die
Moskowiter die Osmanen nicht mehr aufs Knie zwingen. Auch die zufällige
Überlegenheit Englands in Mesopotamien wird daran nichts ändern.
Denn die Entscheidung des Weltkriegs fällt auf den Schlachtfeldern
Europas; außerdem erzittert das englische Weltreich selbst in seinen
Grundfesten. Der Dienst, den die Türkei indirekt Deutschland geleistet
hat, muß daneben auch in Anschlag gebracht werden. Großbritanniens
Zusammenschluß mit Rußland über die Dardanellen und den Bosporus hinweg
war eine der Voraussetzungen für die Zerschmetterung Deutschlands. Bei
Gallipoli wurde <em class="gesperrt">dieser</em> Traum zuschanden.</p>
<p class="calibre13">Die russische Revolution verlief anders, als Englands Selbstsucht
erwartet hatte. Damit war eine der letzten Karten ausgespielt — es
gelang England nicht wie einst im Jahre 1808, Rußland auf Kosten
anderer zu kaufen. Jetzt ist es zu spät! Die Legionen Großbritanniens
verbluten vergeblich an der deutschen Westfront, immer drohender erhebt
sich das Gespenst des Hungers aus den Wogen des Atlantischen Ozeans.
Der Sturz des russischen Zaren besiegelte Englands Mißerfolg und
entschied den Ausgang des Weltkrieges! Deutschland rechnet nicht mehr
mit den Slawen, sie sind matt gesetzt. Das Riesendrama, das schon drei
Jahre lang über die Weltbühne geht, beginnt seinen letzten Akt. Wir
haben erlebt, wie Königreiche vernichtet, Kronen in Stücke zerschlagen
und Verfassungen zerrissen wurden. Überall gärt es, auch in neutralen
Ländern, die jetzt in der Stunde der Entscheidung besser täten, ihre
Ruhe zu bewahren.</p>
<p class="calibre13"><span id="Seite_7" title="[S. 7]"></span></p>
<p class="calibre13">Mitten in diesem hoffnungslosen Durcheinander steht Deutschland
unerschütterlich fest, wie der Fels im aufgewühlten Meer. Die
Sturmwogen, die von allen Seiten hereinbrechen, zerschellen an seinen
Klippen zu Schaum. Habt acht! Der Vorhang rauscht zum letzten Male
empor. Hindenburg tritt auf. Dann wird die gewaltige Kampfgruppe,
die seit dem Feldzug gegen Rumänien zu einer in der Weltgeschichte
unerhörten Vollkommenheit ausgebildet wurde, ihre Ernte einbringen.
Der Krieg wird zur Ruhe gezwungen werden. <em class="gesperrt">Frieden soll wieder auf
dieser gemarterten, zerfleischten, vergrämten Erde herrschen!</em> Stark
und mächtig wird Deutschland der neuen Zeit entgegengehen. Dann darf
auch das osmanische Volk des Dankes gewiß sein für seine ehrenvolle
Teilnahme am Freiheitskampf der Germanen.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?8f3f8f18